import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { EventBusy } from '@material-ui/icons';
import bookingMessages from 'modules/booking/messages';
import { ActionItem } from 'common/components';
import { restrictModifyEventByTime } from 'utils/booking.utils';
import ActionItemWarningIconByTime from 'common/components/ActionsMenu/ActionItemWarningIconByTime';
import BookingActionItemContainer from 'components/Booking/BookingActionItemContainer';

interface IBookingActionItemCancel {
  onClick: () => void;
  secondsBeforeEvent: number;
  cancelRestrictionBeforeDays?: number | null;
}

const BookingActionItemCancel: FC<IBookingActionItemCancel> = ({
  onClick,
  secondsBeforeEvent,
  cancelRestrictionBeforeDays,
}) => {
  const intl = useIntl();
  let disableReason: JSX.Element | null = null;

  if (restrictModifyEventByTime(secondsBeforeEvent, cancelRestrictionBeforeDays)) {
    disableReason = (
      <ActionItemWarningIconByTime
        tooltipMsgType="restrictCancel"
        days={cancelRestrictionBeforeDays}
      />
    );
  }

  const disabled = !!disableReason;

  return (
    <ActionItem
      key="cancelEventAction"
      disabled={disabled}
      onClick={!disabled ? onClick : undefined}
      icon={<EventBusy />}
    >
      <BookingActionItemContainer message={intl.formatMessage(bookingMessages.cancelEventBtn)}>
        {disableReason}
      </BookingActionItemContainer>
    </ActionItem>
  );
};

export default BookingActionItemCancel;
